import React from 'react'
import { Link } from 'react-router-dom'
import LandingNavFemale from './LandingNavFemale'
import FooterFemalePage from './FooterFemalePage'

const ThanksFemalePage = ()=> {
   return (
    <div>
   
          <LandingNavFemale />
    

        <div className="error-page">
            <div>
                {/* <div className="error-page-heading-1">Thanks For Booking</div> */}
                <div className="error-page-heading-1">Your Service Is Confirmed</div>
                <div className="error-page-heading-2">Our expert will contact you shortly</div>
                {/* <div className="error-page-heading-3">Contact: <Link target='blank' to="tel:+919658153153"> +91 9658-153-153</Link></div> */}
                <br />
                <div className="error-page-button"><Link  onClick={() =>  window.history.back()}>Go Back</Link></div>
                <br />
                <div className="error-page-button"><Link to="tel:+919658153153" target="_blank"><i className="fa-solid fa-phone"></i> Book By Call</Link></div>
            </div>
        </div>

        <FooterFemalePage/>
        {/* <ContactButtons/> */}
    </div>
  )
}

export default ThanksFemalePage